import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './LegalPage.css';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1>תנאי שימוש</h1>
            <p className="legal-subtitle">
              התנאים המסדירים את השימוש בפלטפורמת AIweon
            </p>
            <p className="legal-updated">עדכון אחרון: מרץ 2026</p>
          </motion.div>
        </div>
      </section>

      <div className="legal-content">
        {/* Introduction */}
        <section className="legal-section">
          <h2>מבוא</h2>
          <p>
            ברוכים הבאים ל-AIweon (להלן: "הפלטפורמה", "האתר", "אנחנו" או "החברה").
            תנאי שימוש אלו (להלן: "התנאים") מהווים הסכם מחייב בינכם (להלן: "המשתמש" או "אתם")
            לבין AIweon. בגישה לפלטפורמה או בשימוש בה, אתם מאשרים כי קראתם, הבנתם והסכמתם
            לתנאים אלו במלואם.
          </p>
          <p>
            אם אינכם מסכימים לתנאים אלו, אנא הימנעו משימוש בפלטפורמה.
            תנאים אלו חלים בנוסף ל<Link to="/privacy">מדיניות הפרטיות</Link> שלנו,
            המהווה חלק בלתי נפרד מהסכם זה.
          </p>
        </section>

        {/* About the Platform */}
        <section className="legal-section">
          <h2>אודות הפלטפורמה</h2>
          <p>
            AIweon היא פלטפורמת שיווק משפיענים המחברת בין יוצרי תוכן (להלן: "יוצרים")
            לבין מותגים ומפרסמים (להלן: "מותגים"). הפלטפורמה מאפשרת למותגים לפרסם קמפיינים
            שיווקיים וליוצרים להגיש מועמדות והצעות לשיתופי פעולה.
          </p>
          <p>
            AIweon משמשת כמתווכת בלבד בין יוצרים למותגים. אנו אינם צד להסכמים שנכרתים
            ישירות בין יוצרים למותגים דרך הפלטפורמה.
          </p>
        </section>

        {/* Eligibility */}
        <section className="legal-section">
          <h2>כשירות לשימוש</h2>
          <p>השימוש בפלטפורמה מותנה בעמידה בתנאים הבאים:</p>
          <ul>
            <li>גילכם 18 שנים ומעלה.</li>
            <li>אתם בעלי כשרות משפטית להתקשר בהסכם מחייב.</li>
            <li>המידע שתספקו בעת ההרשמה הוא מדויק, עדכני ומלא.</li>
            <li>לא הושעה או נחסם חשבונכם בפלטפורמה בעבר.</li>
          </ul>
        </section>

        {/* Account Registration */}
        <section className="legal-section">
          <h2>רישום חשבון</h2>
          <h3>יצירת חשבון</h3>
          <p>
            לצורך שימוש בפלטפורמה נדרשת הרשמה ויצירת חשבון אישי. בעת ההרשמה תתבקשו
            לספק פרטים אישיים מדויקים בהתאם לסוג החשבון (יוצר תוכן או מותג).
          </p>
          <h3>אבטחת חשבון</h3>
          <ul>
            <li>אתם אחראים לשמירה על סודיות פרטי ההתחברות שלכם.</li>
            <li>אתם אחראים לכל פעולה המתבצעת תחת חשבונכם.</li>
            <li>יש להודיע לנו מיד על כל שימוש לא מורשה בחשבונכם.</li>
            <li>אנו שומרים על הזכות לדרוש אימות נוסף מעת לעת.</li>
          </ul>
          <h3>אישור חשבון יוצר</h3>
          <p>
            חשבונות יוצרי תוכן עוברים תהליך אישור על ידי צוות AIweon. עד לאישור החשבון,
            גישת היוצר לחלק מתכונות הפלטפורמה עשויה להיות מוגבלת.
            אנו שומרים על הזכות לדחות בקשת הרשמה לפי שיקול דעתנו.
          </p>
        </section>

        {/* User Obligations */}
        <section className="legal-section">
          <h2>חובות וכללי התנהגות</h2>
          <p>בעת השימוש בפלטפורמה, אתם מתחייבים:</p>
          <ul>
            <li>לפעול בהתאם לכל דין ותקנה רלוונטיים, לרבות חוק הגנת הצרכן, חוק הגנת הפרטיות וכללי הפרסום של רשויות הפיקוח.</li>
            <li>לספק מידע מדויק ונכון ולעדכנו בהתאם לשינויים.</li>
            <li>לא להתחזות לאדם או גוף אחר.</li>
            <li>לא להעלות תוכן פוגעני, מטעה, בלתי חוקי או מפר זכויות של צד שלישי.</li>
            <li>לא להשתמש בפלטפורמה לצורך ספאם, פישינג או הפצת תוכנות זדוניות.</li>
            <li>לא לנסות לגשת למערכות, חשבונות או מידע שלא הורשיתם אליהם.</li>
            <li>לא להשתמש בכלים אוטומטיים (בוטים, סקריפטים) ללא אישור מראש.</li>
            <li>לציית לכל ההנחיות וכללי הקהילה שנפרסם מעת לעת.</li>
          </ul>
        </section>

        {/* Campaigns and Applications */}
        <section className="legal-section">
          <h2>קמפיינים והגשות</h2>
          <h3>מותגים</h3>
          <ul>
            <li>מותגים אחראים לתוכן הקמפיינים שהם מפרסמים ולעמידה בכל דין רלוונטי.</li>
            <li>תנאי הקמפיין (תגמול, לוחות זמנים, דרישות תוכן) מוגדרים על ידי המותג ומחייבים את הצדדים.</li>
            <li>מותגים מתחייבים לנהוג בהגינות ובתום לב מול היוצרים.</li>
          </ul>
          <h3>יוצרי תוכן</h3>
          <ul>
            <li>יוצרים מתחייבים לספק תוכן מקורי, איכותי ובהתאם לדרישות הקמפיין.</li>
            <li>יוצרים חייבים לגלות בשקיפות כל שיתוף פעולה ממומן בהתאם להנחיות הרגולטור (תיוג תוכן שיווקי).</li>
            <li>יוצרים אחראים לוודא שהתוכן שהם מפרסמים אינו מפר זכויות יוצרים או זכויות של צדדים שלישיים.</li>
          </ul>
        </section>

        {/* Intellectual Property */}
        <section className="legal-section">
          <h2>קניין רוחני</h2>
          <h3>קניין הפלטפורמה</h3>
          <p>
            כל הזכויות בפלטפורמה, לרבות עיצוב, קוד, לוגו, סימני מסחר ותוכן מקורי,
            שייכות ל-AIweon ומוגנות על ידי דיני קניין רוחני. אין להעתיק, לשכפל, להפיץ
            או ליצור יצירות נגזרות ללא אישור בכתב מאיתנו.
          </p>
          <h3>תוכן משתמשים</h3>
          <p>
            אתם שומרים על הבעלות בתוכן שאתם מעלים לפלטפורמה. עם זאת, בהעלאת תוכן,
            אתם מעניקים לנו רישיון לא בלעדי, ללא תמלוגים, להציג, להפיץ ולשתף את התוכן
            במסגרת הפעלת הפלטפורמה בלבד. רישיון זה פג עם מחיקת החשבון או התוכן.
          </p>
        </section>

        {/* Third-Party Services and Advertising */}
        <section className="legal-section">
          <h2>שירותי צד שלישי ופרסום</h2>
          <p>
            הפלטפורמה עשויה לכלול קישורים, אינטגרציות או שירותים של צדדים שלישיים,
            לרבות שירותי פרסום ומעקב. בפרט:
          </p>
          <ul>
            <li>
              <strong>Meta (Facebook/Instagram):</strong> אנו משתמשים בכלי מעקב של Meta
              (כגון Meta Pixel ו-Conversions API) למדידת יעילות פרסומות ולשיפור חוויית המשתמש.
              שימוש בכלים אלו כפוף ל<a href="https://www.facebook.com/legal/terms" target="_blank" rel="noopener noreferrer">תנאי השימוש של Meta</a> ול<a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">מדיניות הפרטיות של Meta</a>.
              מידע נוסף על אופן איסוף הנתונים מפורט ב<Link to="/privacy">מדיניות הפרטיות</Link> שלנו.
            </li>
            <li>
              <strong>Google Cloud:</strong> אנו משתמשים בשירותי ענן של Google לאחסון ועיבוד נתונים.
            </li>
            <li>
              <strong>רשתות חברתיות:</strong> חיבור חשבונות רשתות חברתיות כפוף לתנאי השימוש
              של הפלטפורמות המתאימות (Instagram, TikTok, YouTube וכו').
            </li>
          </ul>
          <p>
            אנו אינם אחראים לתוכן, למדיניות או לפעולות של שירותי צד שלישי.
            מומלץ לעיין בתנאי השימוש ובמדיניות הפרטיות של כל שירות בנפרד.
          </p>
        </section>

        {/* Data Collection and Privacy */}
        <section className="legal-section">
          <h2>איסוף מידע ופרטיות</h2>
          <p>
            איסוף המידע, עיבודו ושמירתו מפורטים ב<Link to="/privacy">מדיניות הפרטיות</Link> שלנו,
            המהווה חלק בלתי נפרד מתנאי שימוש אלו. בפרט:
          </p>
          <ul>
            <li>אנו אוספים מידע אישי הנחוץ להפעלת הפלטפורמה ולמתן השירותים.</li>
            <li>אנו משתמשים בעוגיות (Cookies) ובטכנולוגיות מעקב למדידת ביצועים ולשיפור השירות.</li>
            <li>מידע עשוי להיות משותף עם שותפים עסקיים ומפרסמים בהתאם למדיניות הפרטיות.</li>
            <li>אנו לא מוכרים את המידע האישי שלכם לצדדים שלישיים.</li>
            <li>באפשרותכם לממש את זכויותיכם לעיון, תיקון ומחיקת מידע כמפורט במדיניות הפרטיות.</li>
          </ul>
        </section>

        {/* Limitation of Liability */}
        <section className="legal-section">
          <h2>הגבלת אחריות</h2>
          <p>
            הפלטפורמה מסופקת "כפי שהיא" (AS IS) וללא כל מצג או התחייבות, מפורשים או משתמעים.
            ככל שמותר על פי החוק:
          </p>
          <ul>
            <li>AIweon אינה אחראית לנזקים ישירים, עקיפים, מיוחדים או תוצאתיים הנובעים משימוש בפלטפורמה.</li>
            <li>AIweon אינה אחראית לתוכן שמעלים משתמשים, להתנהלות בין יוצרים למותגים, או לאיכות השירותים שנותנים יוצרים.</li>
            <li>AIweon אינה מבטיחה זמינות רציפה וללא הפרעות של הפלטפורמה.</li>
            <li>AIweon אינה אחראית לאובדן הכנסות, נתונים או הזדמנויות עסקיות.</li>
          </ul>
          <p>
            אחריותנו הכוללת כלפיכם בכל מקרה לא תעלה על הסכום ששילמתם לנו (אם בכלל)
            ב-12 החודשים שקדמו לאירוע.
          </p>
        </section>

        {/* Indemnification */}
        <section className="legal-section">
          <h2>שיפוי</h2>
          <p>
            אתם מתחייבים לשפות ולהגן על AIweon, מנהליה, עובדיה ושלוחיה מפני כל תביעה,
            נזק, הפסד, הוצאה או חבות (לרבות שכר טרחת עורכי דין) הנובעים מ:
          </p>
          <ul>
            <li>הפרת תנאי שימוש אלו על ידכם.</li>
            <li>הפרת זכויות של צד שלישי, לרבות זכויות קניין רוחני.</li>
            <li>תוכן שהעליתם או פרסמתם באמצעות הפלטפורמה.</li>
            <li>שימוש שעשיתם בפלטפורמה שלא בהתאם לתנאים אלו.</li>
          </ul>
        </section>

        {/* Termination */}
        <section className="legal-section">
          <h2>סיום וביטול חשבון</h2>
          <h3>ביטול על ידי המשתמש</h3>
          <p>
            באפשרותכם לבטל את חשבונכם בכל עת על ידי פניה אלינו. לאחר הביטול,
            מידע אישי יטופל בהתאם ל<Link to="/privacy">מדיניות הפרטיות</Link> שלנו.
          </p>
          <h3>ביטול על ידי AIweon</h3>
          <p>
            אנו שומרים על הזכות להשעות או לסגור חשבונות בכל עת, לפי שיקול דעתנו, במקרים הבאים:
          </p>
          <ul>
            <li>הפרת תנאי שימוש אלו.</li>
            <li>מסירת מידע כוזב או מטעה.</li>
            <li>פעילות שנחשבת לבלתי חוקית או פוגענית.</li>
            <li>אי-שימוש ממושך בפלטפורמה (מעל 12 חודשים).</li>
          </ul>
        </section>

        {/* Changes to Terms */}
        <section className="legal-section">
          <h2>שינויים בתנאי השימוש</h2>
          <p>
            אנו שומרים על הזכות לעדכן ולשנות תנאים אלו מעת לעת. במקרה של שינויים מהותיים,
            נודיע לכם באמצעות הודעה בפלטפורמה או בדוא"ל לפחות 30 ימים מראש.
            המשך השימוש בפלטפורמה לאחר כניסת השינויים לתוקף מהווה הסכמה לתנאים המעודכנים.
          </p>
          <p>
            גרסאות קודמות של תנאי השימוש זמינות לעיון על פי בקשה.
          </p>
        </section>

        {/* Governing Law */}
        <section className="legal-section">
          <h2>דין חל וסמכות שיפוט</h2>
          <p>
            תנאים אלו כפופים לדיני מדינת ישראל. כל מחלוקת הנובעת מתנאים אלו או הקשורה
            אליהם תידון בבית המשפט המוסמך בתל אביב-יפו, ישראל.
          </p>
        </section>

        {/* Severability */}
        <section className="legal-section">
          <h2>הפרדת תנאים</h2>
          <p>
            אם ייקבע כי סעיף כלשהו בתנאים אלו אינו תקף או אינו ניתן לאכיפה,
            יתר הסעיפים ימשיכו לעמוד בתוקפם. הסעיף שנפסל יוחלף בסעיף תקף
            הקרוב ביותר לכוונתו המקורית.
          </p>
        </section>

        {/* Contact */}
        <section className="legal-section">
          <h2>יצירת קשר</h2>
          <p>לכל שאלה בנוגע לתנאי השימוש:</p>
          <div className="legal-contact-card">
            <h3>AIweon — מחלקה משפטית</h3>
            <p>דוא"ל: <a href="mailto:legal@aiweon.co.il">legal@aiweon.co.il</a></p>
            <p>טלפון: <a href="tel:+972522398911">052-239-8911</a></p>
            <p>
              ניתן גם ליצור קשר דרך <Link to="/contact">טופס יצירת הקשר</Link> שבאתר.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
